module.exports = __webpack_public_path__ + "img/notice.24a9a0ce.png";